import React from 'react';

export default function StopRecordingIcon({ color }: { color: string }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
      <g fill="none" fillRule="evenodd">
        <g fill={color}>
          <path
            d="M15 3.333c.92 0 1.667.747 1.667 1.667v10c0 .92-.747 1.667-1.667 1.667H5c-.92 0-1.667-.747-1.667-1.667V5c0-.92.747-1.667 1.667-1.667h10zm0 .834H5c-.427 0-.78.321-.828.736L4.167 5v10c0 .427.321.78.736.828l.097.005h10c.427 0 .78-.321.828-.736l.005-.097V5c0-.427-.321-.78-.736-.828L15 4.167zm-.833 1.666v8.334H5.833V5.833h8.334z"
            transform="translate(-175 -158) translate(150 141) translate(1 9) translate(24 8)"
          />
        </g>
      </g>
    </svg>
  );
}
